import type { LandingPageContent } from '../types'

export const ZAPLANUJ_INSTALACJE_FOTOWOLTAICZNA: LandingPageContent = {
  slug: 'zaplanuj-instalacje-fotowoltaiczna',
  lang: 'pl',
  topicId: 'photovoltaik-planen',
  title: 'Zaplanuj instalację fotowoltaiczną – krok po kroku',
  metaDescription:
    'Od analizy dachu po uruchomienie: tak poprawnie zaplanujesz swoją instalację fotowoltaiczną - ' +
    'wszystkie kroki w jednym miejscu.',
  keywords: [
    'zaplanuj instalację fotowoltaiczną',
    'jak zaplanować panele słoneczne',
    'kroki instalacji fotowoltaicznej',
    'planowanie fotowoltaiki krok po kroku',
    'fotowoltaika dom szeregowy',
  ],
  eyebrow: 'Przewodnik po planowaniu',
  h1: 'Zaplanuj instalację fotowoltaiczną: droga do własnej instalacji solarnej',
  intro:
    'Od pierwszej analizy dachu po gotową instalację prowadzi kilka jasnych kroków. Ten przewodnik ' +
    'pokazuje cały proces w jednym miejscu - i w każdym punkcie linkuje do odpowiednich narzędzi i ' +
    'stron Roofora.',
  sections: [
    { type: 'heading', text: 'Krok 1: przeanalizuj dach i zużycie energii' },
    {
      type: 'paragraph',
      text:
        'Orientacja i kąt nachylenia dachu, dostępna powierzchnia oraz Twoje roczne zużycie energii ' +
        '(w tym pompa ciepła lub samochód elektryczny, jeśli je masz) to podstawa każdego planowania. ' +
        'Zwykle wystarczy kilka zdjęć dachu i rozdzielnicy zrobionych telefonem.',
    },
    { type: 'heading', text: 'Krok 2: ustal odpowiednią wielkość instalacji' },
    {
      type: 'paragraph',
      text:
        'Na podstawie tych danych Roofora automatycznie oblicza odpowiednią konfigurację instalacji - ' +
        'wielkość, moc i to, czy opłaca się magazyn energii - bezpośrednio przy tworzeniu Twojego ' +
        'zapytania, bez potrzeby wiedzy technicznej ani dodatkowych narzędzi.',
    },
    { type: 'heading', text: 'Krok 3: zbierz i porównaj oferty firm rzemieślniczych' },
    {
      type: 'paragraph',
      text:
        'Zamiast obdzwaniać pojedyncze firmy, składasz anonimowe zapytanie. Kilka firm rzemieślniczych ' +
        'składa na nie niewiążące oferty, które porównujesz posortowane według ceny.',
    },
    { type: 'heading', text: 'Krok 4: wybierz firmę i zezwól na kontakt' },
    {
      type: 'paragraph',
      text:
        'Sprawdzasz profil i ofertę każdej zainteresowanej firmy i indywidualnie decydujesz, komu ' +
        'udostępniasz swoje dane kontaktowe - bez zbiorowej zgody dla wszystkich.',
    },
    { type: 'heading', text: 'Krok 5: instalacja i uruchomienie' },
    {
      type: 'paragraph',
      text:
        'Termin, montaż i zgłoszenie instalacji odbywają się bezpośrednio między Tobą a wybraną firmą ' +
        'rzemieślniczą - bez dalszego pośrednictwa. Po montażu możesz ocenić firmę w Roofora.',
    },
  ],
  faq: [
    {
      q: 'Ile trwa planowanie do pierwszej oferty?',
      a: 'Samo zapytanie tworzy się w kilka minut. Potem firmy rzemieślnicze mają 2-4 tygodnie na złożenie oferty.',
    },
    {
      q: 'Czy potrzebuję wiedzy wstępnej, aby zaplanować instalację?',
      a: 'Nie - odpowiednia konfiguracja jest obliczana automatycznie na podstawie Twoich danych o dachu i zużyciu energii.',
    },
    {
      q: 'Czy planowanie działa też przy szeregówce z ograniczoną powierzchnią dachu?',
      a: 'Tak - podaj "dom szeregowy" jako typ budynku, firmy rzemieślnicze skalkulują ofertę bezpośrednio dla faktycznie dostępnej, często węższej powierzchni dachu.',
    },
  ],
  primaryCta: { label: 'Zacznij planowanie już teraz', action: 'customer' },
  secondaryCta: { label: 'Ile kosztuje instalacja fotowoltaiczna?', action: 'link', href: '/koszt-instalacji-fotowoltaicznej' },
  relatedLinks: [
    { label: 'Koszt instalacji fotowoltaicznej', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Złóż zapytanie fotowoltaiczne', href: '/zlozyc-zapytanie-fotowoltaiczne' },
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
    { label: 'Potrzebujesz tylko montażu na dachu?', href: '/montaz-paneli-fotowoltaicznych' },
    { label: 'Potrzebujesz tylko instalacji elektrycznej?', href: '/instalacja-elektryczna-fotowoltaiki' },
    { label: 'Jak Roofora oblicza wydajność wg orientacji dachu?', href: '/jak-obliczamy-cene' },
  ],
}
